import { getLocalizedOrDefault } from "../../../../../helpers/Functions";

function mapField(list, collection, id_field, maps) {
  return (
    list
      .map(({ [id_field]: id }) => maps[collection][id])
      // Remove nulls
      .filter((v) => !!v)
  );
}

const QuickComparePageConfig = {
  collection: "quick_compare_page",
  single: true,
  fields: [
    "id",

    "heading_color",
    "audience.audience",
    "audience.locale.language",
    "audience.locale.enabled_price_types.price_types_id",
    "audience.locale.enabled_attributes.attributes_id",
    "audience.locale.heading",

    "audience.locale.description",
    "audience.locale.enable_view_comparison",
    "audience.locale.enable_email_comparison",

    "audience.locale.view_comparison_cta_label",
    "audience.locale.view_comparison_base_url",
    "audience.locale.email_placeholder",
    "audience.locale.email_cta_label",
    "audience.locale.model_dropdown_prefix"
  ],

  adapter: class QuickComparePage {
    constructor(qcp) {
      this.id = qcp.id;

      // Arbitrary ID name
      this.html_id = `quick-compare-${this.id}`;

      this.heading_color = qcp.heading_color || "";

      const { audience = [] } = qcp;
      this.audience = audience;
    }

    map(collections, maps) {
      // { field_name: default_value }
      const audienced_localized_fields = {
        enabled_price_types: [],
        enabled_attributes: [],
        heading: "",
        description: "",
        view_comparison_cta_label: "",
        view_comparison_base_url: "",
        email_placeholder: "",
        email_cta_label: "",
        enable_view_comparison: "",
        enable_email_comparison: "",
        model_dropdown_prefix: ""
      };

      // Create functions for each of the above field names,
      // so that each field name becomes a function which
      // returns an audienced, localized value
      Object.entries(audienced_localized_fields).forEach(
        ([field_name, default_value]) => {
          this[field_name] = (selected_audience, selected_locale) => {
            const pivots = {
              audience: selected_audience,
              locale: selected_locale
            };
            const { global_settings } = collections;
            const { default_audience, default_locale } = global_settings;
            const default_pivots = {
              audience: default_audience,
              locale: default_locale.language
            };
            const pivoted_value = getLocalizedOrDefault(
              this,
              field_name,
              pivots,
              default_pivots
            );
            return pivoted_value || default_value;
          };
        }
      );

      // Renaming for legacy functions
      // (for example, PageDataCollector's mapQuickCompareExportData)
      this.selected_pricing = this.enabled_price_types;
      this.selected_specifications = this.enabled_attributes;

      // Populate global values for this page
      // TODO: this setting could come (localized) from the QC page itself
      this.quick_compare_inks_header =
        collections.global_settings.quick_compare_inks_header;

      // Repopulate audiences, mapping any fields
      this.audience = this.audience.reduce(
        (audience_acc, { audience, locale = [] }) => ({
          ...audience_acc,
          [maps.audiences[audience].key]: {
            locale: locale.reduce((locale_acc, { language, ...other_data }) => {
              const { enabled_price_types, enabled_attributes } = other_data;
              return {
                ...locale_acc,
                [maps.locales[language].language]: {
                  ...other_data,

                  // Map related values
                  enabled_price_types: mapField(
                    enabled_price_types,
                    "price_types",
                    "price_types_id",
                    maps
                  ),
                  enabled_attributes: mapField(
                    enabled_attributes,
                    "attributes",
                    "attributes_id",
                    maps
                  )
                }
              };
              // end reduce locale
            }, {})
          }
          // end reduce audience
        }),
        {}
      );
      // e.g. field_name: header
      //      selected_locale: 'es-CL'
    }
  }
};

export default QuickComparePageConfig;
